import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import CalculatorPage from "@/pages/CalculatorPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminLeadsPage from "@/pages/AdminLeadsPage";
import ProtectedRoute from "@/components/admin/ProtectedRoute";
import { AuthProvider } from "@/lib/AuthContext";
import { Toaster } from "@/components/ui/sonner";

export default function App() {
  return (
    <div className="App min-h-screen bg-[#0A0F1C] text-white font-body">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<CalculatorPage />} />
            <Route path="/admin" element={<Navigate to="/admin/leads" replace />} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route
              path="/admin/leads"
              element={
                <ProtectedRoute>
                  <AdminLeadsPage />
                </ProtectedRoute>
              }
            />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster richColors position="top-right" theme="dark" />
    </div>
  );
}
